module.exports = __webpack_public_path__ + "static/media/thumb_female_new.4f838d5f.png";